import appTravelRequests from "../../views/appSettings/travelRequests.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "travel-requests";
  const params = ["page", "limit", "travel_date", "resolved", "from", "to"];
  $stateProvider.state("travelrequests", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appTravelRequests,
      },
    },
    reloadOnSearch: false,
    data: { title: "Travel Requests" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/travelRequests/travelRequests.urls.js